import { useCustomSearchData } from "@redux/slices/searchResultsCustomization";
import { ProductCategory } from "@utils/constants";

export const getHeaderBulkOption = (
  customSearchData: any,
  productType: ProductCategory,
  priceMode: number,
  t: any
) => {
  const dataObject = customSearchData?.[productType];
  if (!dataObject?.header?.["sub-sections"]) {
    return { bulkActions: null, requestItems: null };
  }

  const bulkActionItem = dataObject.header["sub-sections"]?.bulk_action;
  if (!bulkActionItem) {
    return { bulkActions: null, requestItems: null };
  }

  const extractOptions = (section: any) =>
    Object.values(section?.options || {})
      .filter((option: any) => option?.price_modes?.includes(priceMode))
      .sort((a: any, b: any) => parseFloat(a?.order) - parseFloat(b?.order));

  const bulkActions = extractOptions(bulkActionItem);

  const requestItemOptions = extractOptions(bulkActionItem)
    .filter((item: any) => item?.name === "request_items")
    .flatMap((item: any) =>
      Object.values(item?.options || {})
        .filter((option: any) => option?.price_modes.includes(priceMode))
        .map((option: any) => ({
          ...option,
          label: t(option?.label),
        }))
    )
    .sort((a: any, b: any) => parseFloat(a?.order) - parseFloat(b?.order));

  return {
    bulkActions,
    requestItems: requestItemOptions.flat(),
  };
};

export const useHeaderBulkOption = (
  productType: ProductCategory,
  priceMode: number,
  t: any
) => {
  const customSearchData = useCustomSearchData();
  return getHeaderBulkOption(customSearchData, productType, priceMode, t);
};
